export default __webpack_public_path__ + "static/media/P2-Plunger.760aea02.svg";